import { i18n } from 'next-i18next/pages';

export const loadNamespaces = async (namespaces: string[]) => {
  const instance = i18n;
  if (!instance?.isInitialized) return;

  const missing = namespaces.filter(namespace => !instance.hasLoadedNamespace(namespace));
  if (missing.length > 0) await instance.loadNamespaces(missing);
};
